import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import success from "../../../public/svgs/success.svg";
function SuccessIcon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Image src={success} alt="success icon" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export default SuccessIcon;